<template>
  <div class="relative inline-block" ref="root" @keydown.esc="close">
    <button
      class="h-full flex justify-center items-center border border-grey-light px-4 rounded-[6px] gap-1 text-sm select-none"
      type="button"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="menu"
      @click="toggle"
    >
      <DownloadIcon class="w-5 h-5 text-primary" />
      <span>คู่มือการใช้งาน</span>
    </button>

    <div
      v-if="open"
      class="absolute right-[0px] mt-[8px] w-full rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#fff] overflow-hidden"
      role="menu"
      @click.capture.stop
    >
      <a
        class="group flex items-start gap-3 py-[10px] px-[8px] text-[#1F1D1F] hover:bg-[#FBEFF8] cursor-pointer"
        :href="PDFS.officer"

        rel="noopener"
        role="menuitem"
        @click.stop="deferClose"
      >
        <span class="labelL group-hover:text-[#9B237B]">คู่มือเจ้าหน้าที่</span>
      </a>

      <a
        class="group flex items-start gap-3 py-[10px] px-[8px] text-[#1F1D1F] hover:bg-[#FBEFF8] cursor-pointer"
        :href="PDFS.citizen"
        rel="noopener"
        role="menuitem"
        @click.stop="deferClose"
      >
        <span class="labelL group-hover:text-[#9B237B]">คู่มือประชาชน</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import DownloadIcon from "@/assets/icons/download.icon.vue";

const open = ref(false);
const root = ref(null);

const PDFS = {
  officer:
    "https://disaster-backend.gentechsoft.tech/api/download-user-doc/user",
  citizen:
    "https://disaster-backend.gentechsoft.tech/api/download-user-doc/pupulation", // ตรวจสะกดด้วย
};

function toggle() {
  open.value = !open.value;
}
function deferClose() {
  setTimeout(close, 0);
}
function close() {
  open.value = false;
}
function onClickOutside(e) {
  if (!root.value) return;
  if (!root.value.contains(e.target)) close();
}
onMounted(() => document.addEventListener("click", onClickOutside));
onBeforeUnmount(() => document.removeEventListener("click", onClickOutside));
</script>

<style lang="scss">
.labelL {
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.1px;
}
</style>
